import { CONTENT_TYPE, ContentType } from '../types/types';

export const primaryCategories = {
  ENTERPRISES_AND_COMMUNITIES: 'Yritykset ja yhteisöt',
  PUBLIC_LAW: 'Julkisoikeus',
  CONTRACTS: 'Sopimukset ja velkasuhteet',
  LABOUR_LAW_AND_HR: 'Työoikeus ja HR',
  CRIMINAL_AND_PROCEDURAL_LAW: 'Rikos ja prosessi',
  HOUSING_ENVIRONMENT_AND_CONSTRUCTION: 'Ympäristö, asuminen ja rakentaminen',
  FAMILY_AND_INHERITANCE_LAW: 'Henkilö, perhe ja perintö',
  TAXATION: 'Verotus',
  FINANCING_INSURANCES_AND_INVESTING: 'Rahoitus, vakuutus ja sijoittaminen',
  FINANCIAL_MANAGEMENT: 'Taloushallinto',
};

export function getRegulationFeedCategories() {
  return Object.values(primaryCategories);
}

export function getPrimaryCategories(contentType?: ContentType): string[] {
  // return all primary categories if content type is CONTENT_TYPE.LegalNews except FINANCIAL_MANAGEMENT.
  if (contentType === CONTENT_TYPE.LegalNews) {
    return Object.values(primaryCategories).filter((category) => {
      return category !== primaryCategories.FINANCIAL_MANAGEMENT;
    });
  }

  // Any other content type has all primary categories except FINANCING_INSURANCES_AND_INVESTING and FINANCIAL_MANAGEMENT.
  return Object.values(primaryCategories).filter((category) => {
    return (
      category !== primaryCategories.FINANCING_INSURANCES_AND_INVESTING &&
      category !== primaryCategories.FINANCIAL_MANAGEMENT
    );
  });
}

export const secondaryCategories = {
  INTELLECTUAL_PROPERTY_RIGHTS: 'IPR',
  ARTIFICIAL_INTELLIGENCE: 'Tekoälyoikeus',
  DATA_PROTECTION: 'Tietosuoja',
  // ESG = Environmental, social, and corporate governance
  ESG: 'ESG',
  CORPORATE_RESPONSIBILITY: 'Yritysvastuu',
  COMPLIANCE: 'Compliance',
  COMPETITION_LAW: 'Kilpailuoikeus',
  STOCK_MARKET: 'Arvopaperimarkkinat',
  CONSUMER_PROTECTION: 'Kuluttajansuoja',
  REQUESTS_FOR_INFORMATION: 'Tietopyynnöt',
  PUBLIC_PROCUREMENT: 'Julkiset hankinnat',
  DATA_GOVERNANCE: 'Datan sääntely',
  HEALTHCARE: 'Hyvinvointioikeus',
  SOTE_REGULATION: 'Sote-sääntely',
  LEGAL_DESIGN: 'Legal design',
  WORK_SAFETY: 'Työturvallisuus',
  WORK_HEALTHCARE: 'Työhyvinvointi',
  CO_OPERATION_ACT: 'Yhteistoiminta',
  CRIMINAL_SANCTIONS: 'Rangaistuskäytäntö',
  INSOLVENCY_LAW: 'Insolvenssioikeus',
  YSE: 'YSE-ehdot',
  CLIMATE_CHANGE_ACT: 'Ilmasto-oikeus',
  CHILD_LAW: 'Lapsioikeus',
  MEDIATION: 'Sovittelu',
  ARBITRATION: 'Välitysmenettely',
  JUSTICE_THEORY: 'Oikeusteoria',
  PRECAUTIONARY_MEASURES: 'Turvaamistoimet',
  HUMAN_RIGHTS: 'Perus- ja ihmisoikeudet',
  DAMAGES: 'Vahingonkorvaus',
  MONEY_LAUNDERING_PREVENTION: 'Rahanpesun torjunta',
  LOCAL_AGREEMENTS: 'Paikallinen sopiminen',
  CONSTRUCTION_LAW: 'Raksan laki',
};

export const categoryMap = {
  [primaryCategories.FAMILY_AND_INHERITANCE_LAW]: [
    secondaryCategories.HEALTHCARE,
    secondaryCategories.CHILD_LAW,
    secondaryCategories.HUMAN_RIGHTS,
  ],
  [primaryCategories.PUBLIC_LAW]: [
    // secondaryCategories.PUBLIC_PROCUREMENT,
    secondaryCategories.HUMAN_RIGHTS,
    secondaryCategories.HEALTHCARE,
    // secondaryCategories.SOTE_REGULATION,
    // secondaryCategories.REQUESTS_FOR_INFORMATION,
  ],
  [primaryCategories.CRIMINAL_AND_PROCEDURAL_LAW]: [
    secondaryCategories.JUSTICE_THEORY,
    secondaryCategories.CRIMINAL_SANCTIONS,
    secondaryCategories.MEDIATION,
    secondaryCategories.PRECAUTIONARY_MEASURES,
    secondaryCategories.DATA_PROTECTION,
    secondaryCategories.INSOLVENCY_LAW,
    secondaryCategories.HUMAN_RIGHTS,
  ],
  [primaryCategories.CONTRACTS]: [
    secondaryCategories.DAMAGES,
    secondaryCategories.ARBITRATION,
    secondaryCategories.JUSTICE_THEORY,
  ],
  [primaryCategories.LABOUR_LAW_AND_HR]: [
    secondaryCategories.LOCAL_AGREEMENTS,
    // secondaryCategories.WORK_HEALTHCARE,
    secondaryCategories.WORK_SAFETY,
    secondaryCategories.CO_OPERATION_ACT,
    secondaryCategories.PRECAUTIONARY_MEASURES,
    secondaryCategories.HUMAN_RIGHTS,
  ],
  [primaryCategories.TAXATION]: [],
  [primaryCategories.HOUSING_ENVIRONMENT_AND_CONSTRUCTION]: [
    // secondaryCategories.CLIMATE_CHANGE_ACT,
    // secondaryCategories.YSE,
    secondaryCategories.MEDIATION,
    secondaryCategories.CONSTRUCTION_LAW,
    secondaryCategories.INSOLVENCY_LAW,
  ],
  [primaryCategories.ENTERPRISES_AND_COMMUNITIES]: [
    secondaryCategories.STOCK_MARKET,
    secondaryCategories.DATA_GOVERNANCE,
    secondaryCategories.ESG,
    secondaryCategories.INTELLECTUAL_PROPERTY_RIGHTS,
    secondaryCategories.COMPETITION_LAW,
    // secondaryCategories.LEGAL_DESIGN,
    secondaryCategories.ARTIFICIAL_INTELLIGENCE,
    secondaryCategories.DATA_PROTECTION,
    secondaryCategories.CORPORATE_RESPONSIBILITY,
    // secondaryCategories.MONEY_LAUNDERING_PREVENTION,
    secondaryCategories.ARBITRATION,
    secondaryCategories.INSOLVENCY_LAW,
    secondaryCategories.CONSUMER_PROTECTION,
    secondaryCategories.JUSTICE_THEORY,
  ],
};

export const isKnownCategory = (category?: string): boolean => {
  if (!category) {
    return false;
  }

  return Object.values({
    ...primaryCategories,
    ...secondaryCategories,
  }).includes(category);
};
